<mat-table [dataSource]="cookies">

  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef i18n="name of column that contains cookie name"> Name </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="description">
    <mat-header-cell *matHeaderCellDef i18n="name of column that contains cookie description"> Description </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.description}} </mat-cell>
  </ng-container>
  
  <ng-container matColumnDef="thirdParties">
    <mat-header-cell *matHeaderCellDef i18n="name of column that contains information about third party cookies"> Third parties </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.thirdParties}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="duration">
    <mat-header-cell *matHeaderCellDef i18n="name of column that contains information about duration of cookie"> Duration </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.duration}} </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="['name', 'description', 'thirdParties', 'duration']"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['name', 'description', 'thirdParties', 'duration']"></mat-row>
</mat-table>
